<template>
  <section class="py-5 container">
    <h4>Historial cotizaciones</h4>
    <hr />
    <LoadingSpinner v-if="cotizaciones.length === 0" />
    <template v-else>
      <vue-good-table
        :rows="cotizaciones"
        :columns="columns"
        row-style-class="text-sm text-center"
        :search-options="{ enabled: true, placeholder: 'Buscar...' }"
        :pagination-options="{ enabled: true, perPage: 10 }"
        styleClass="vgt-table condensed bordered striped"
      >
        <template #table-row="props">
          <span v-if="props.column.field == 'cliente'">
            <span class="text-md fw-bold">{{ props.row.cliente }}</span>
            <template v-if="usuario.es_lider || usuario.id == 9">
              <br />
              <span class="text-xxs text-secondary"
                >Cotizó:
                {{
                  capitalizarTexto(
                    `${props.row.usuario.nombre} ${props.row.usuario.paterno} ${props.row.usuario.materno}`
                  )
                }}</span
              >
            </template>
          </span>
          <span v-if="props.column.field == 'linea'">
            ${{ formatoMoneda(props.row.linea, false) }}
          </span>
          <span v-if="props.column.field == 'aforo'">
            {{ props.row.aforo_porcentaje }}%<br />
            <p class="text-xxs text-muted mb-0 text-secondary">
              ${{ formatoMoneda(props.row.aforo_cantidad, true) }}
            </p>
          </span>
          <span v-if="props.column.field == 'comision_apertura'">
            {{ props.row.comision_apertura }}%<br />
            <p class="text-xxs text-muted mb-0 text-secondary">
              ${{ formatoMoneda(props.row.comision_apertura_cantidad, true) }}
            </p>
          </span>
          <span v-if="props.column.field == 'comision_disposicion'">
            {{ props.row.comision_disposicion }}%<br />
            <p class="text-xxs text-muted mb-0 text-secondary">
              ${{
                formatoMoneda(props.row.comision_disposicion_cantidad, true)
              }}
            </p>
          </span>
          <span v-if="props.column.field == 'plazo'">
            {{ props.row.plazo }} días
          </span>
          <span v-if="props.column.field == 'tasa'">
            {{ props.row.tasa }}%<br />
            <p class="text-xxs text-muted mb-0 text-secondary">
              ${{ formatoMoneda(props.row.tasa_cantidad, true) }}
            </p>
          </span>
          <span v-if="props.column.field == 'monto_a_recibir'">
            ${{ formatoMoneda(props.row.monto_a_recibir, false) }}
          </span>
          <span v-if="props.column.field == 'monto_factura'">
            ${{ formatoMoneda(props.row.monto_factura, false) }}
          </span>
          <span v-if="props.column.field == 'acciones'">
            <router-link
              :to="{
                name: 'factoraje-cotizacion-detalle',
                params: { cotizacion_id: props.row.token },
              }"
            >
              <ArgonButton size="sm" color="secondary" target="_blank">
                Ver cotización
              </ArgonButton>
            </router-link>
          </span>
        </template>
      </vue-good-table>
    </template>
  </section>
</template>

<script setup>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueGoodTable } from "vue-good-table-next";
import LoadingSpinner from "@/components/LoadingComponent.vue";
import "vue-good-table-next/dist/vue-good-table-next.css";
import { useCotizacionFactorajeHistorial } from "@/composables/useCotizacionFactoraje";
import useUtil from "@/composables/useUtil";
const { formatoMoneda, capitalizarTexto } = useUtil();
const {
  cotizaciones,
  loading,
  getCotizaciones,
  columns,
  usuario,
} = useCotizacionFactorajeHistorial();

getCotizaciones();
</script>
